export default __webpack_public_path__ + "locales/lo-LA/BackupCodesDialog.json?hash=3fe1fc7cb2a0c3c406c5bf9e9568d3cb";